import { putAwayApi } from 'api';
import { generatePutAwayInstructionPdf } from 'utils/pdfGenerators';
import { PRINT_PAGE_SIZE_STORAGE_KEYS } from 'constants/printPageSize';
import { getPreferredPrintPageSize } from 'utils/printPageSize';

export {
  groupInstructionByShelf,
  getInstructionGrnSourceCode,
} from 'utils/putAwayInstruction';

export const PUT_AWAY_INSTRUCTION_ERROR_CODES = {
  NOT_COMPLETED: 'PUT_AWAY_NOT_COMPLETED',
  UNAVAILABLE: 'PUT_AWAY_INSTRUCTION_UNAVAILABLE',
};

const ERROR_MESSAGES = {
  [PUT_AWAY_INSTRUCTION_ERROR_CODES.NOT_COMPLETED]:
    'The instruction is available after the putaway is completed.',
  [PUT_AWAY_INSTRUCTION_ERROR_CODES.UNAVAILABLE]:
    'No instruction is available for this putaway.',
};

const FALLBACK_ERROR_MESSAGE = 'Error generating instruction PDF';

/** Toast-ready message for an instruction API failure. */
export const getPutAwayInstructionErrorMessage = error => {
  if (error?.response?.status === 404) {
    return 'Putaway not found.';
  }

  const data = error?.response?.data;
  const errorCode = [].concat(data?.error_code || [])[0];

  return ERROR_MESSAGES[errorCode] ?? FALLBACK_ERROR_MESSAGE;
};

/**
 * Fetch the put-away instruction and open it in a print window.
 *
 * `pageSize` is one of PRINT_PAGE_SIZES and defaults to the last size the
 * user printed an instruction with. `printContext` ({ tenantName,
 * warehouseName }) is printed under the title.
 *
 * Rejects with the API error so callers can show
 * getPutAwayInstructionErrorMessage(error).
 */
export const printPutAwayInstructionPdf = async (
  putawayId,
  pageSize = getPreferredPrintPageSize(
    PRINT_PAGE_SIZE_STORAGE_KEYS.PUT_AWAY_INSTRUCTION,
  ),
  printContext = {},
) => {
  const instruction = await putAwayApi.getPutawayInstruction(putawayId);
  generatePutAwayInstructionPdf(instruction, pageSize, printContext);
};
